<div class="container" fusePerfectScrollbar>
    <div class="full-grow-no-shrink-no-basis">
        <div class="flex flex-col justify-start items-start">
            <h3 class="component-heading m-b-10">Timing</h3>
            <form [formGroup]="selectorForm" class="w-p-100">
                <mat-form-field appearance="outline" class="w-p-100">
                    <mat-label>Time Zone *</mat-label>
                    <mat-select disabled value='Select Timezone'
                                [(value)]="selectedTimezone" (selectionChange)="onSelectionChange($event)">
                        <mat-option *ngFor="let timeZone of allTimeZones"
                                    [value]="timeZone.id">{{timeZone.displayText}}</mat-option>
                    </mat-select>
                    <mat-error
                            *ngIf="selectorForm.get('timezone').hasError('required') ||selectorForm.get('timezone').invalid && (selectorForm.get('timezone').dirty || selectorForm.get('timezone').touched)">
                        Please choose a timezone
                    </mat-error>
                </mat-form-field>
            </form>


            <!--      <kendo-timepicker-->
            <!--        #departureTime-->
            <!--        name="time"-->
            <!--        format="HH:mm"-->
            <!--        [(ngModel)]="time"-->
            <!--        (valueChange)="handleChange($event)"-->
            <!--        [popupSettings]="{ popupClass: 'kendo-timepicker' }"-->
            <!--      ></kendo-timepicker>-->
            <mat-form-field appearance="outline" class="w-p-100">
                <mat-label>Delivery Time *</mat-label>
                <mat-select value='Select Time'
                            [(value)]="timePeriod" (selectionChange)="handleChange($event.value)">
                    <mat-option *ngFor="let timePeriod of availableTimePeriods"
                                [value]="timePeriod">{{timePeriod}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="divider"></div>

        <particle-dynamic-country-selector *ngIf="isReady"
                                           [isRegionTabEnabled]="true"
                                           [selectorTitle]="'Selected (Orbitax Tax News)'"
                                           [configKey]="configKey"
                                           [selectedCountryCodes]="selectedOrbitaxCountryCodes"
                                           (selectionChanged)="onCountrySelectionChanged($event)"
                                           [isCheckboxDisabled]="false"
                                           [regionSelectionConfigKey]="'RegionCategorizedCountries'"
        ></particle-dynamic-country-selector>
        <div class="divider"></div>

        <particle-dynamic-country-selector *ngIf="isReady"
                                           [isRegionTabEnabled]="true"
                                           [selectorTitle]="'Selected (EY Tax Alerts)'"
                                           [configKey]="'EYAlertCountries'"
                                           [selectedCountryCodes]="selectedEyCountryCodes"
                                           (selectionChanged)="onEYCountrySelectionChanged($event)"
                                           [isCheckboxDisabled]="false"
                                           [regionSelectionConfigKey]="'EYRegionCategorizedCountries'"
        ></particle-dynamic-country-selector>

      <div class="divider"></div>

      <particle-dynamic-country-selector *ngIf="isReady"
                                         [isRegionTabEnabled]="true"
                                         [selectorTitle]="'Selected (Pagero Tax Alerts)'"
                                         [configKey]="'PageroAlertCountries'"
                                         [selectedCountryCodes]="selectedPageroCountryCodes"
                                         (selectionChanged)="onPageroCountrySelectionChanged($event)"
                                         [isCheckboxDisabled]="false"
                                         [regionSelectionConfigKey]="'PageroRegionCategorizedCountries'"
      ></particle-dynamic-country-selector>
    </div>
</div>
